// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"174":"efa61e61","359":"8ffc058f","728":"74dadd4a","864":"d737a6eb"}[chunkId] + ".js";
};